export const PROGRAM_COLORS = {
  EAP_YELLOW: "#f2b443",
  EAP_GREEN: "#78c0a1",
  EAP_ACCESS: "#34c1d6",
};
